/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Vue from 'vue';

export const generateGuid = () => {
    function s4 () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export default (vue: typeof Vue) => {
    vue.directive('click-outside', {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        bind (el: HTMLElement, binding: any) {
            if (el.id === undefined || el.id.length === 0) {
                el.id = generateGuid();
            }

            // Define Handler and cache it on the element
            const bubble = binding.modifiers.bubble;
            const handler = (e: MouseEvent) => {
                let clickedEl = e.target;
                if (bubble || (el.id !== (clickedEl as HTMLElement).id)) {
                    while (clickedEl) {
                        if ((clickedEl as HTMLElement).id === el.id) {
                            return;
                        }
                        clickedEl = (clickedEl as HTMLElement).parentElement;
                    }
                    binding.value(e);
                }
            };
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            el.__vueClickOutside__ = handler;
            // add Event Listeners
            document.addEventListener('click', handler);
        },

        unbind (el) {
            // Remove Event Listeners
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            document.removeEventListener('click', el.__vueClickOutside__);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            el.__vueClickOutside__ = null;
        },
    });
};
